import React, { useEffect, useRef } from 'react'
import { List, Card } from 'antd'
import { useLyricProcessor } from 'hooks/lyric'
import './styles.scss'
import { animated, useSpring } from 'react-spring'
import { forEach, map } from 'lodash'

const VerseText = ({ text }) => <Card>{text}</Card>
export const LyricsView = () => {
  const ref = useRef()
  const itemEls = useRef()
  const { items, currentVerse } = useLyricProcessor()
  const [scrollProps, set, stop] = useSpring(() => ({
    scroll: 0,
  }))

  useEffect(() => {
    ref.current = window.document.querySelector('.lyrics-view')

    if (!ref.current) return
    itemEls.current = ref.current.children
  }, [])

  useEffect(() => {
    if (!itemEls.current || !ref.current || !currentVerse) return

    const height = ref.current.offsetHeight
    forEach(itemEls.current, (el) => el.classList.remove('active'))

    const itemEl = itemEls.current[currentVerse.index]
    if (!itemEl) return

    itemEl.classList.add('active')

    const y1 = itemEl.offsetTop + itemEl.offsetHeight
    const y = y1 > height / 2 ? y1 - height / 2 : 0

    set({
      scroll: y,
    })
  }, [currentVerse, itemEls])

  return (
    <animated.div className="lyrics-view" scrollTop={scrollProps.scroll}>
      {map(items, (item) => (
        <VerseText key={item.index} {...item} />
      ))}
      {/* <List className="lyrics-view" dataSource={items} renderItem={VerseText} /> */}
    </animated.div>
  )
}
